import React, { useState, useEffect } from 'react';
import {
  LayoutDashboard,
  User,
  MapPin,
  MapPinned,
  GraduationCap,
  ChevronUp,
  ChevronDown,
  Briefcase,
  FileText,
  Menu,
} from 'lucide-react';
import {
  FaBars,
  FaTimes
} from 'react-icons/fa';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import TopNavbar from '../../top-navbar/TopNav';
import '../../top-navbar/topnavBar.css';

const Navbar = () => {
  const [showEmployeeSubMenu, setShowEmployeeSubMenu] = useState(false);
  const [showClientSubMenu, setShowClientSubMenu] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getTitleForPage = () => {
    const path = location.pathname;
    const state = location.state;

    if (state?.heading) return state.heading;
    // if (path.includes('dashboard')) return 'Dashboard';
    if (path.includes('view-profile')) return 'View Profile';
    if (path.includes('pending')) return 'Pending Client List';
    if (path.includes('rejected')) return 'Rejected Client List';
    if (path.includes('clients')) return 'Approved Client List';
    if (path.includes('reports')) return 'Candidate Report';
    if (path.includes('add-employee')) return 'Add New Agent';
    if (path.includes('inactive-employee')) return 'Inactive Agent';
    if (path.includes('active-employee')) return 'Active Agent';
    if (path.includes('employee') && path.includes('candidates')) return 'Assigned Candidates';
    if (path.includes('/admin/candidates/')) return 'Candidates By Status';
    if (path.includes('candidates')) return 'Client Candidates';
    if (path.includes('candidate-details')) return 'Candidate Details';
    if (path.includes('service-down')) return 'Service Down';
    // return 'Dashboard';
  };

  const sidebarWidth = '12rem';

  return (
    <div className="admin-dashboard-container">
      <TopNavbar />

      <button
        className="admin-hamburger-btn"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        {isSidebarOpen ? <FaTimes /> : <FaBars />}
      </button>

      <aside
        className={`admin-dashboard-sidebar ${isSidebarOpen ? 'open' : ''}`}
        style={{ width: sidebarWidth }}
      >
        <button
          className="admin-sidebar-close-btn"
          onClick={() => setIsSidebarOpen(false)}
        >
          <FaTimes />
        </button>

        <nav>
          <ul className="admin-sidebar-menu">
            <li
              className={`admin-sidebar-menu-item ${location.pathname === '/admin' ? 'active' : ''}`}
              onClick={() => navigate('/admin')}
            >
              <LayoutDashboard className="admin-sidebar-icon" />
              <span>Dashboard</span>
            </li>
            <div className="admin-sidebar-divider"></div>

            <li
              className={`admin-sidebar-menu-item ${location.pathname === '/admin/view-profile' ? 'active' : ''}`}
              onClick={() => navigate('/admin/view-profile')}
            >
              <User className="admin-sidebar-icon" />
              <span>View Profile</span>
            </li>
            <div className="admin-sidebar-divider"></div>

            <li
  onClick={() => setShowClientSubMenu(!showClientSubMenu)}
  className="admin-sidebar-menu-item"
>
  <div className="items-center">
    <User className="admin-sidebar-icon" />
    <span>Clients</span>
  </div>
  {showClientSubMenu ? <ChevronUp /> : <ChevronDown />}
</li>

{showClientSubMenu && (
  <ul className="admin-sidebar-submenu">

    {/* Pending */}
    <li
      className={`admin-sidebar-submenu-item ${
        location.pathname === '/admin/clients/pending' ? 'active' : ''
      }`}
      onClick={() => navigate('/admin/clients/pending')}
    >
      <MapPinned className="admin-sidebar-icon sub-icon" />
      <span>Pending Approvals</span>
    </li>

    {/* Approved */}
    <li
      className={`admin-sidebar-submenu-item ${
        location.pathname === '/admin/clients/approved' ||
        location.pathname === '/admin/clients'
          ? 'active'
          : ''
      }`}
      onClick={() => navigate('/admin/clients')}
    >
      <Briefcase className="admin-sidebar-icon sub-icon" />
      <span>Approved Clients</span>
    </li>

    {/* Rejected */}
    <li
      className={`admin-sidebar-submenu-item ${
        location.pathname === '/admin/clients/rejected' ? 'active' : ''
      }`}
      onClick={() => navigate('/admin/clients/rejected')}
    >
      <Briefcase className="admin-sidebar-icon sub-icon" />
      <span>Rejected Clients</span>
    </li>

  </ul>
)}

<div className="admin-sidebar-divider"></div>


            <li
              className={`admin-sidebar-menu-item ${location.pathname === '/admin/add-employee' ? 'active' : ''}`}
              onClick={() => navigate('/admin/add-employee')}
            >
              <MapPin className="admin-sidebar-icon" />
              <span>Add Agent</span>
            </li>
            <div className="admin-sidebar-divider"></div>

            <li
              onClick={() => setShowEmployeeSubMenu(!showEmployeeSubMenu)}
              className="admin-sidebar-menu-item"
            >
              <div className="items-center">
                <GraduationCap className="admin-sidebar-icon" />
                <span>Agent List</span>
              </div>
              {showEmployeeSubMenu ? <ChevronUp /> : <ChevronDown />}
            </li>

            {showEmployeeSubMenu && (
              <ul className="admin-sidebar-submenu">
                <li
                  className={`admin-sidebar-submenu-item ${location.pathname === '/admin/active-employee' ? 'active' : ''
                    }`}
                  onClick={() => navigate('/admin/active-employee')}
                >
                  <Briefcase className="admin-sidebar-icon sub-icon" />
                  <span>Active Agents</span>
                </li>
                <li
                  className={`admin-sidebar-submenu-item ${location.pathname === '/admin/inactive-employee' ? 'active' : ''
                    }`}
                  onClick={() => navigate('/admin/inactive-employee')}
                >
                  <FileText className="admin-sidebar-icon sub-icon" />
                  <span>Inactive Agents</span>
                </li>
              </ul>
            )}
          </ul>
        </nav>
      </aside>

      {isSidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}

      <main className="admin-dashboard-main">
        <div className="admin-dashboard-header-row">
          <div className="admin-dashboard-title-bar">
            <h2 className="admin-page-title">{getTitleForPage()}</h2>
          </div>
        </div>

        <div className="admin-dashboard-page-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Navbar;
